module.exports = __webpack_public_path__ + "img/没有打扫的家.fcafafbd.png";